export default "/images/right.svg?561cdd4b4718dc250c259f085fbddd91";